export default {
      id: "font-c copy-usage",
      viewBox: "0 0 512 494",
      url: __webpack_public_path__ + "img/svg-sprite.svg#font-c copy",
      toString: function () {
        return this.url;
      }
    }